// Import centralized configuration
import { API_BASE_URL, BASE_URL } from '../config/env'

export { API_BASE_URL }
// IMAGE_BASE_URL should point to the image.php API endpoint
export const IMAGE_BASE_URL = `${API_BASE_URL}/image.php`

// Static assets URL - uses BASE_URL for consistency
export const ASSETS_URL = `${BASE_URL}/backend/uploads`

// Default pagination settings
export const DEFAULT_PAGINATION = {
  per_page: 10,
  max_per_page: 100
}

// File upload settings
export const UPLOAD_SETTINGS = {
  max_file_size: 5 * 1024 * 1024, // 5MB
  allowed_types: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
  image_quality: 0.8
}

// SEO settings
export const SEO_LIMITS = {
  meta_title_max: 60,
  meta_description_max: 160,
  excerpt_max: 200
}

// Status mappings
export const STATUS_LABELS = {
  published: 'Δημοσιευμένο',
  draft: 'Προσχέδιο',
  archived: 'Αρχειοθετημένο',
  active: 'Ενεργό',
  inactive: 'Ανενεργό'
}

// Helper functions
export const getImageUrl = (filename: string, type: string = 'post') => {
  if (!filename) return ''
  return `${IMAGE_BASE_URL}?type=${type}&file=${filename}`
}

export const getAssetUrl = (path: string) => {
  return `${ASSETS_URL}/${path}`
}

export const formatDate = (dateString: string, locale: string = 'el-GR') => {
  return new Date(dateString).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const truncateText = (text: string, maxLength: number = 100) => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength).trim() + '...'
}

// Greek-to-Latin transliteration map (covers all modern Greek letters + accented variants)
const GREEK_MAP: Record<string, string> = {
  'α': 'a', 'ά': 'a', 'ἀ': 'a', 'ἁ': 'a', 'ἂ': 'a', 'ἃ': 'a', 'ἄ': 'a', 'ἅ': 'a',
  'β': 'v',
  'γ': 'g',
  'δ': 'd',
  'ε': 'e', 'έ': 'e', 'ἐ': 'e', 'ἑ': 'e', 'ἒ': 'e', 'ἓ': 'e', 'ἔ': 'e', 'ἕ': 'e',
  'ζ': 'z',
  'η': 'i', 'ή': 'i', 'ἠ': 'i', 'ἡ': 'i', 'ἢ': 'i', 'ἣ': 'i', 'ἤ': 'i', 'ἥ': 'i', 'ἦ': 'i', 'ἧ': 'i',
  'θ': 'th',
  'ι': 'i', 'ί': 'i', 'ϊ': 'i', 'ΐ': 'i', 'ἰ': 'i', 'ἱ': 'i', 'ἲ': 'i', 'ἳ': 'i', 'ἴ': 'i', 'ἵ': 'i',
  'κ': 'k',
  'λ': 'l',
  'μ': 'm',
  'ν': 'n',
  'ξ': 'x',
  'ο': 'o', 'ό': 'o', 'ὀ': 'o', 'ὁ': 'o', 'ὂ': 'o', 'ὃ': 'o', 'ὄ': 'o', 'ὅ': 'o',
  'π': 'p',
  'ρ': 'r',
  'σ': 's', 'ς': 's',
  'τ': 't',
  'υ': 'y', 'ύ': 'y', 'ϋ': 'y', 'ΰ': 'y', 'ὐ': 'y', 'ὑ': 'y', 'ὒ': 'y', 'ὓ': 'y', 'ὔ': 'y', 'ὕ': 'y',
  'φ': 'f',
  'χ': 'ch',
  'ψ': 'ps',
  'ω': 'o', 'ώ': 'o', 'ὠ': 'o', 'ὡ': 'o', 'ὢ': 'o', 'ὣ': 'o', 'ὤ': 'o', 'ὥ': 'o', 'ὦ': 'o', 'ὧ': 'o',
}

export const generateSlug = (text: string): string => {
  return text
    .toLowerCase()
    .split('')
    .map(c => GREEK_MAP[c] ?? c)
    .join('')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}
